<template>
  <a class="btn btn-plain position-relative d-flex"
     v-if="jetAPIPanelEnabled"
     @click="toggleJetAPIChat">
    <WazzupSvg class="svg-wazzup svg-light"/>
    <span class="notification-bubble header-panel-bubble" v-if="counter > 0">
      {{ counter }}
    </span>
  </a>
</template>

<script setup>
import WazzupSvg from '@/assets/svg-vue/header/chat.svg'
import { computed } from "vue"
import { useStore } from "vuex"

const store = useStore()

const toggleJetAPIChat = () => {
  store.state.dom.rightPaneOpened = !store.state.dom.rightPaneOpened
  store.commit('clearPanelNotifications')
}

const counter = computed(() => store.state.crm.newPanelJetApiNotifications)

const jetAPIPanelEnabled = computed(() => store.getters.jetAPIPanelEnabled)
</script>
